import { apiRequest } from '../apiRequest';

export const sendTelegramTestApi = async (chatId, message = '') => {
  return apiRequest('/admin/notification/telegram-destinations/test', {
    method: 'POST',
    body: {
      chat_id: chatId,
      message,
    },
    defaultErrorMessage: 'Failed to send Telegram test message',
  });
};
